import 'react-toastify/dist/ReactToastify.css';

import React from 'react';
import { Slide, toast, ToastContainer } from 'react-toastify';
import Icon from 'ViatoUi/Shared/DataDisplay/Icon';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';

import styles from './Snackbar.module.scss';

const SnackbarContainer = () => {
	return (
		<ToastContainer
			className={styles.snackbar}
			closeButton={
				<FlexBox alignItems='center' justifyContent='center'>
					<Icon className={styles.close} color='bright' icon='fa-times' iconWeight='far' size='s' />
				</FlexBox>
			}
			draggable={false}
			transition={Slide}
			hideProgressBar
		/>
	);
};

const snackbar = {
	primary(msg, options = {}) {
		return toast(msg, {
			...options,
			className: `${styles.snackbarInner} ${styles.primary}`
		});
	},
	secondary(msg, options = {}) {
		return toast(msg, {
			...options,
			className: `${styles.snackbarInner} ${styles.secondary}`
		});
	},
	success(msg, options = {}) {
		return toast.success(msg, {
			...options,
			className: `${styles.snackbarInner} ${styles.success}`
		});
	},
	danger(msg, options = {}) {
		return toast.error(msg, {
			...options,
			className: `${styles.snackbarInner} ${styles.danger}`
		});
	},
	error(msg, options = {}) {
		return toast.error(msg, {
			...options,
			className: `${styles.snackbarInner} ${styles.danger}`
		});
	},
	warning(msg, options = {}) {
		return toast.error(msg, {
			...options,
			className: `${styles.snackbarInner} ${styles.warning}`
		});
	},
	info(msg, options = {}) {
		return toast(msg, {
			...options,
			className: `${styles.snackbarInner} ${styles.info}`
		});
	},
	light(msg, options = {}) {
		return toast(msg, {
			...options,
			className: `${styles.snackbarInner} ${styles.light}`
		});
	},
	bright(msg, options = {}) {
		return toast(msg, {
			...options,
			className: `${styles.snackbarInner} ${styles.bright}`
		});
	},
	dark(msg, options = {}) {
		return toast(msg, {
			...options,
			className: `${styles.snackbarInner} ${styles.dark}`
		});
	},
	dismiss(id) {
		return toast.dismiss(id);
	}
};

export { SnackbarContainer, snackbar };
